// A seleção é explícita: miniaturas e contagem de placas não comprovam
// quais peças entraram no produto. Uma seleção inválida não libera o projeto inteiro.
export function normalizarPlacas3d(placas) {
  if (!Array.isArray(placas) || !placas.length || placas.some(p => !Number.isSafeInteger(p) || p < 1)) return [];
  return [...new Set(placas)].sort((a, b) => a - b);
}

export function placasFatiadasDoResultado(placas) {
  if (!Array.isArray(placas) || !placas.length
      || placas.some(p => !Number.isFinite(p?.predictionSeconds) || p.predictionSeconds <= 0)) return [];
  return normalizarPlacas3d(placas.map(p => p.index));
}

// Cria o registro para o destino permanente sem carregar o endereço temporário.
export function arquivoPermanente3d(origem, { nome, path, url }) {
  const placasSelecionadas = normalizarPlacas3d(origem?.placasSelecionadas);
  return { nome, path, url, ...(placasSelecionadas.length ? { placasSelecionadas, origemSelecao3d: origem?.origemSelecao3d || "fatiamento" } : {}) };
}

function descritorPublico(modelo, selecao, automatica = false) {
  if (!modelo || typeof modelo.nome !== "string" || !/\.(3mf|stl|obj)$/i.test(modelo.nome.trim())) return null;
  const placas = normalizarPlacas3d(selecao);
  if ((!placas.length && !automatica) || typeof modelo.url !== "string") return null;
  try {
    const url = new URL(modelo.url);
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password) return null;
  } catch { return null; }
  const base = { url: modelo.url, nome: modelo.nome.trim(), placas };
  return placas.length ? base : { ...base, automatica: true };
}

// Exibição é sempre explícita — só existe quando o vendedor escolheu um
// modelo de exibição pro produto (Calculadora, ao salvar) ou confirmou as
// placas em Configurar3D. Não tenta adivinhar a partir de qualquer arquivo
// anexado (esse era o comportamento antigo, removido: o botão "Ver em 3D"
// aparecia ou não de forma inconsistente, dependendo do arquivo usado pra
// fatiar).
export function visualizacao3dDoItem(item) {
  if (!item || typeof item !== "object" || !item.visualizacao3d) return null;
  return descritorPublico(item.visualizacao3d, item.visualizacao3d.placas, item.visualizacao3d.automatica === true);
}

// Constrói o descritor de exibição a partir de UM arquivo específico recém
// anexado (não uma varredura de vários candidatos) — usado quando o vendedor
// escolhe explicitamente esse arquivo como modelo de exibição. Só retorna
// algo quando as placas já foram resolvidas sem ambiguidade (placa única de
// STL/OBJ, ou 3mf com detecção confiável / seleção manual do vendedor em
// Configurar3D) — nunca um chute.
export function visualizacao3dDoArquivo(arquivo) {
  return descritorPublico(arquivo, arquivo?.placasSelecionadas, false);
}

// Todos os uploads usam o mesmo preparo. Uma seleção já confirmada tem prioridade.
export async function prepararArquivo3d(file, arquivo, origem = {}) {
  const base = arquivoPermanente3d(origem, arquivo);
  if (Object.prototype.hasOwnProperty.call(origem, "placasSelecionadas")) {
    return { ...base, placasSelecionadas: normalizarPlacas3d(origem.placasSelecionadas), origemSelecao3d: origem.origemSelecao3d || "fatiamento" };
  }
  if (/\.(stl|obj)$/i.test(base.nome || "")) return { ...base, placasSelecionadas: [1], origemSelecao3d: "placa-unica" };
  if (!/\.3mf$/i.test(base.nome || "")) return base;
  try {
    const { detectarPlacasFatiadas3mf } = await import("./modelo3mf");
    const resultado = await detectarPlacasFatiadas3mf(file);
    return { ...base, placasSelecionadas: resultado.placas, origemSelecao3d: resultado.origem };
  } catch {
    // Upload continua disponível; não publica placas cuja geometria não foi confirmada.
    return { ...base, placasSelecionadas: [], origemSelecao3d: "selecao-necessaria" };
  }
}
